export function paymentProviderFor({ currency, mobileRef = null, fallbackProvider = null } = {}) {
  if (mobileRef) return "paystack";
  if (fallbackProvider === "bachs") return "bachs";
  return currency === "USD" ? "bachs" : "paystack";
}
